import React from "react";

const InvalidTokenBox = () => (
  <div className="invalid-token-box-conatiner">
    This Token is already expired or is invalid
  </div>
);

export default InvalidTokenBox;
